type FindingKey = 'website' | 'brand' | 'mission' | 'locations' | 'news' | 'industry';

type FindingState = 'done' | 'running' | 'pending';

type Finding = { key: string; state: FindingState };

const PHASE_I18N: Record<FindingKey, string> = {
  website: 'authentication:trial_scan_phase_website',
  brand: 'authentication:trial_scan_phase_brand',
  mission: 'authentication:trial_scan_phase_mission',
  locations: 'authentication:trial_scan_phase_locations',
  news: 'authentication:trial_scan_phase_news',
  industry: 'authentication:trial_scan_phase_industry',
};

export function scanStatusKey(findings: Finding[], isDone: boolean) {
  if (isDone) return 'authentication:trial_scan_ready';

  const running = findings.find((finding) => finding.state === 'running');

  if (running && running.key in PHASE_I18N) {
    return PHASE_I18N[running.key as FindingKey];
  }

  return 'authentication:trial_scan_reading';
}

const SCAN_BAR_RAMP_SECONDS = 8.3;
const SCAN_BAR_CAP_UNTIL_DONE = 92;

export function scanProgressPercent(findings: Finding[], isDone: boolean) {
  if (isDone) return 100;

  const done = findings.filter((finding) => finding.state === 'done').length;

  if (!done) return 0;

  return Math.min(SCAN_BAR_CAP_UNTIL_DONE, Math.round((done / findings.length) * 90) + 5);
}

export function mergeScanBarDisplayPercent(
  findingsPct: number,
  elapsedPct: number,
  isDone: boolean,
) {
  if (isDone) return 100;

  return Math.min(SCAN_BAR_CAP_UNTIL_DONE, Math.max(findingsPct, elapsedPct));
}

export function elapsedScanBarPercent(elapsedSeconds: number) {
  return Math.min(
    SCAN_BAR_CAP_UNTIL_DONE,
    Math.round((elapsedSeconds / SCAN_BAR_RAMP_SECONDS) * SCAN_BAR_CAP_UNTIL_DONE),
  );
}
